import { styled } from '@mui/material/styles';

export const PhoneWrapper = styled('div')`
  width: 250px;
  height: 490px;
  border-radius: 25px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-sizing: border-box;
  border: 4px solid ${({ theme }) => theme.palette.grey[900]};
  overflow: auto;
  scrollbar-width: thin;

  & .mention {
    background-color: ${({ theme }) => theme.palette.grey[400]};
    border-radius: ${({ theme }) => theme.shape.borderRadius}px;
    padding-left: 3px;
    padding-right: 3px;
  }
`;

export const TopBar = styled('div')`
    width: 77px;
    height: 15px;
    background: ${({ theme }) => theme.palette.grey[900]};
    border-bottom-left-radius: ${({ theme }) => theme.shape.borderRadius}px;
    border-bottom-right-radius: ${({ theme }) => theme.shape.borderRadius}px;
    position: absolute;
`

export const Screen = styled('div')`
  background-color: ${({ theme }) => theme.palette.grey[100]};
  width: 100%;
  min-height: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
`;

export const ChatBubble = styled('div', {
  shouldForwardProp: prop => prop !== '$isUser',
})<{ $isUser: boolean }>`
  background-color: ${({ theme, $isUser }) =>
    $isUser ? theme.palette.primary.main : theme.palette.background.messageBubble};
  color: ${({ theme, $isUser }) =>
    $isUser ? theme.palette.common.white : theme.palette.text.primary};
  padding: 10px 15px;
  margin: 5px;
  border-radius: 18px;
  max-width: 80%;
  align-self: ${props => (props.$isUser ? 'flex-end' : 'flex-start')};
  word-break: break-word;
  max-height: 50%;
  overflow-y: auto;
  white-space: pre-wrap;
`;

export const ChatContainer = styled('div')`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
`;

export const ImgDisplayer = styled('img')`
    width: 100%;
    height: auto;
`;
